import { render, staticRenderFns } from "./platformManagement.vue?vue&type=template&id=c7b604a6&scoped=true"
import script from "./platformManagement.vue?vue&type=script&lang=ts"
export * from "./platformManagement.vue?vue&type=script&lang=ts"
import style0 from "./platformManagement.vue?vue&type=style&index=0&id=c7b604a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b604a6",
  null
  
)

export default component.exports